<template>
	<div class="action">
		<a-card class="visit-count">
			<div class="titles">
				账号变更申请
				<span v-hasPermission="'accountPriceApply:selfPage'" @click="$router.push({ path: '/account/accountChange/selfAccountPrice' })">我的申请>></span>
				<span v-hasPermission="'accountPriceApply:page'" @click="$router.push({ path: '/account/accountChange/acountPrice' })">申请列表>></span>
			</div>
			<a-radio-group v-model="radioType" @change="radioChange">
				<a-badge :count="todoNum"><a-radio-button value="1">待处理</a-radio-button></a-badge>
				<a-radio-button value="2">已处理</a-radio-button>
			</a-radio-group>
			<div class="home-approval">
				<ul class="approval-list">
					<li class="approval-item" v-for="(item, index) in dataList" @click="detail(item)">
						<div style="display: flex;justify-content: space-between;">
							<span class="header">{{ item.taskName }}</span>
							<span>&nbsp;</span>
						</div>
						<span class="commit-time" v-if="radioType == 1">创建时间: {{ item.createTime }}</span>
						<span class="commit-time" v-if="radioType == 2">完成时间: {{ item.operatingTime }}</span>
					</li>
				</ul>
			</div>
		</a-card>
		<AccountPriceApplyEdit :visibleEdit="dialog" @close="dialog=false" @success="dialog=false,list();" ref="dialog"/>
		<AccountPriceApplyView :visibleEdit="dialog2" @close="dialog2=false" @success="dialog2=false,list();" ref="dialog2"/>
	</div>
</template>

<script>
import AccountPriceApplyEdit from './accountPriceApplyEdit'
import AccountPriceApplyView from './accountPriceApplyView'

export default {
	components: {
		AccountPriceApplyEdit,
		AccountPriceApplyView
	},
    props:{
        type:String,
    },
    data() {
        return {
            dataList: [],
			radioType: '1',
			todoNum: 0,
			dialog: false,
			dialog2: false,
        }
    },
	mounted() {
		this.list();
	},
    methods:{
		radioChange(e) {
			this.radioType = e.target.value;
			this.list();
			this.$root.Bus.$on('accountPriceHome',function(){
				this.list();
			})
		},
    	list() {
    		this.$get('flowTask/getHomePageData', {businessType: 'account', type: this.radioType }).then(res => {
    			let result = res.data;
    			this.dataList = result.dataList;
    			this.todoNum = result.count;
				this.$emit("success", this.todoNum);
    		});
    	},
		detail(record){
			this.$get("accountPriceApply/getById",{id: record.id}).then(res => {
				let accountPriceApply = res.data;
				if(['team_leader_resubmit','audit_resubmit'].includes(accountPriceApply.applyStatus) && accountPriceApply.existsTask){
					this.dialog = true;
					this.$refs.dialog.setFormValues(accountPriceApply);
				}else{
					this.dialog2 = true;
					this.$refs.dialog2.setFormValues(accountPriceApply);
				}
			});
		}
    }
}
</script>



// WEBPACK FOOTER //
// src/views/account/accountChange/accountPrice/accountPriceHome.vue